// Foliage alpha describes holes in leaves, rather than glass-like translucency.
// Keep it in the opaque depth pass so glass and overlapping leaves occlude it.
export function preparePlantMaterials(root) {
  root.traverse(node => {
    if (node.name !== 'mesh' || !/_Plant(?:\.\d{3})?$/i.test(node.id)) return
    // Mesh.material exposes the mounted proxy; preparation uses the GLB source.
    const source = node._material
    if (!source || !(source.transparent || source.alphaTest > 0)) return
    const material = source.clone()
    material.onBeforeCompile = source.onBeforeCompile
    material.transparent = false
    material.alphaTest = source.alphaTest > 0 ? source.alphaTest : 0.5
    material.depthTest = true
    material.depthWrite = true
    material.needsUpdate = true
    node.material = material
  })
}
